import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/BannerDocumentedProps";

import("./Banner.less");

const allowedBannerWidths = [120, 125, 160, 180, 234, 240, 250, 300, 468, 728];
const allowedBannerHeights = [60, 90, 125, 150, 240, 250, 400, 600];
const allowedHorizontalPositions = ["right", "center"];
const allowedVerticalPositions = ["top", "bottom"];
const allowedHrefTargets = {
    blank: "_blank",
    self: "_self",
    parent: "_parent",
    top: "_top",
    framename: "framename"
};

export default class Banner extends React.Component {
    constructor(props) {
        super(props);

        this.redirect = this.redirect.bind(this);
    }

    buildContainerClass(isClickable) {
        let extraClasses = this.props.extraClasses || "";
        let containerClass = extraClasses + " tq-panel tq-banner";
        containerClass += this.props.textBackground ? " tq-text-background" : "";
        containerClass += this.props.darkText ? " tq-dark-text" : "";
        containerClass += this.props.imageOverlay ? " tq-banner-overlay" : "";

        //Horizontal size
        if (this.props.width && allowedBannerWidths.includes(this.props.width)) {
            containerClass += " tq-banner-w-" + this.props.width;
        }

        //Vertical size
        if (this.props.height && allowedBannerHeights.includes(this.props.height)) {
            containerClass += " tq-banner-h-" + this.props.height;
        }

        //Horizontal alignment
        if (allowedHorizontalPositions.includes(this.props.horizontalAlignment)) {
            containerClass += " tq-text-" + this.props.horizontalAlignment;
        }
        //Vertical alignment
        if (allowedVerticalPositions.includes(this.props.verticalAlignment)) {
            containerClass += " tq-text-" + this.props.verticalAlignment;
        }

        if (isClickable && !this.props.button) {
            containerClass += "  tq-clickable";
        }

        return containerClass;
    }

    redirect() {
        if (this.props.href) {
            let hrefTarget = allowedHrefTargets[this.props.hrefTarget] || allowedHrefTargets.blank;
            window.open(this.props.href, hrefTarget);
        }
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {
        let isClickable = this.props.onClick || this.props.href;
        let containerClass = this.buildContainerClass(isClickable);

        let onClick;
        if (isClickable && !this.props.button) {
            onClick = this.redirect;
        }

        let style = { backgroundImage: "url('" + this.props.image + "')" };

        return (
            <div className={containerClass} onClick={onClick} style={style}>
                <div className="tq-banner-content">
                    {this.props.children}
                    {this.props.description && (
                        <div className="tq-banner-description">
                            <span className="tq-text-node">{this.props.description}</span>
                        </div>
                    )}
                    {this.props.button && (
                        <button className="tq-button" onClick={this.redirect}>
                            <span className="tq-text-node">{this.props.buttonLabel}</span>
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

Banner.displayName = "Banner";

Banner.propTypes = {
    extraClasses: PropTypes.string,
    description: PropTypes.string,
    titleList: PropTypes.array,
    textBackground: PropTypes.bool,
    darkText: PropTypes.bool,
    imageOverlay: PropTypes.bool,
    button: PropTypes.bool,
    buttonLabel: PropTypes.string,

    horizontalAlignment: PropTypes.oneOf(allowedHorizontalPositions),
    verticalAlignment: PropTypes.oneOf(allowedVerticalPositions),
    width: PropTypes.number,
    height: PropTypes.number,
    onClick: PropTypes.func,
    href: PropTypes.string,
    hrefTarget: PropTypes.oneOf(Object.keys(allowedHrefTargets)),
    image: PropTypes.string
};

Banner.documentedProps = documentedProps;
